/*
 * @Author: stevensh 
 * @Date: 2020-02-28 11:07:50 
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-03-02 17:23:34
 */
class StoreManager {
   storeObjectTree:any = {};
    register = (storeName:string, store:{}) => {
      if (this.storeObjectTree[storeName]) {
        throw new Error(`已经存在${storeName}的store，请更换moduleName`);
      }
      this.storeObjectTree[storeName] = store;
    };
    getStores = () => {
      return { ...this.storeObjectTree };
    };
    getStore = (storeName:string) => {
      if (!this.storeObjectTree[storeName]) {
        throw new Error(`不存在${storeName}的store`);
      }
      return this.storeObjectTree[storeName];
    };
  }
  
  export default new StoreManager();